import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

export const absenceCustomLabelsStyles: StyleRulesCallback = () => ({
  root: {
    textAlign: 'center',
    marginTop: '24px',
  },
});
